export default function Loader() {
  return <div style={{ textAlign: 'center' }}>Loading...</div>;
}
